import React, { useState, useEffect } from "react";
import { MoveLeft, Calendar, Clock } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dropdown, Button, Modal, Spinner } from "react-bootstrap";
import chevron_down from "../../assets/Vehicles/chevron_down.png";
import DatePicker from "react-datepicker";
import plus from "../../assets/svg/Inspection/plus.svg";
import CommonDropdown from "../common/common_dropDown";
import { getInspectionListApi, getVehicleDetailsApi } from "./inspection-api.js";
import CommonStaticDropdown from "../common/common_static_dropdown.jsx";
import ErrorExtractor from "../common/error_extractor";
import DOMPurify from "dompurify";
import { submitInspectionAPI, saveAttachmentApi, updateInspectionAPI, getInspectionEditApi } from "./inspection-api.js";

export const AddInspection = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  useEffect(() => {
    if (id != null && id !== 0) {
      getInspectionEdit(id);
    }
  }, [id]);
  // form date
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  //   interior details
  const [items, setItems] = useState([
    { id: 1, label: "Mirrors", checked: false },
    { id: 2, label: "Check Seats", checked: false },
    { id: 3, label: "Electronics", checked: false },
    { id: 4, label: "Medical Kit", checked: false },
    { id: 5, label: "Fuel Level", checked: false },
  ]);
  const [itemsRemoved, setItemsRemoved] = useState([]);
  //   exterior details
  const [exteriorItems, setExteriorItems] = useState([
    { id: 1, label: "Mirrors", checked: false },
    { id: 2, label: "Check Seats", checked: false },
    { id: 3, label: "Electronics Seats", checked: false },
  ]);
  const [exteriorItemsRemoved, setExteriorItemsRemoved] = useState([]);

  const [showInteriorModal, setShowInteriorModal] = useState(false);
  const [showExteriorModal, setShowExteriorModal] = useState(false);
  const [newLabel, setNewLabel] = useState("");
  const [newLabelError, setNewLabelError] = useState("");

  const inspectionTypeList = [
    {
      label: "Daily Vehicle Inspection",
      value: "Daily Vehicle Inspection",
    },
    {
      label: "Periodic Vehicle Inspection",
      value: "Periodic Vehicle Inspection",
    },
  ];

  const [licensePlateOption, setLicensePlateOption] = useState(null);
  const [vehicleName, setVehicleName] = useState("");
  const [inspectionTypeOption, setInspectionTypeOption] = useState(null);
  const [kilometer, setKilometer] = useState("");

  const handleInspectionTypeSelect = (item) => {
    setInspectionTypeOption(item);
  };

  const handleSelectLicensePlate = (item) => {
    setLicensePlateOption(item); // store selected id
    getVehicleDetails(item.value);
  };
  const getVehicleDetails = async (id) => {
    try {
      const response = await getVehicleDetailsApi(id);
      console.log(response.data);
      if (response.data.success === true) {
        setVehicleName(response.data.vehicle?.name ?? "");
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const [errorMsg, setErrorMsg] = useState({
    vehicle_id: "",
    type: "",
    start_date: "",
    start_time: "",
    submitted_date: "",
    submitted_time: "",
    km: "",
    interiors: "",
    exteriors: "",
    removed_interiors: "",
    removed_exteriors: "",
  });

  const [isLoader, setIsLoader] = useState(false);

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      if (!licensePlateOption?.value || !inspectionTypeOption?.value || !startDate || !startTime || !endDate || !endTime) {
        setErrorMsg((prev) => ({
          ...prev,
          vehicle_id: !licensePlateOption?.value ? "License plate is required" : "",
          type: !inspectionTypeOption?.value ? "Inspection type is required" : "",
          start_date: !startDate ? "Start date is required" : "",
          start_time: !startTime ? "Start time is required" : "",
          submitted_date: !endDate ? "Submitted date is required" : "",
          submitted_time: !endTime ? "Submitted time is required" : "",
        }));
        setIsLoader(false);
        return;
      }

      const preSanitizeData = {
        vehicle_id: licensePlateOption != null ? licensePlateOption.value : "",
        type: inspectionTypeOption != null ? inspectionTypeOption.value : "", // Periodic, Daily, name, start_date
        start_date: startDate != null && startDate !== "" ? startDate.toLocaleDateString("en-CA") : "",
        start_time:
          startTime != null && startTime !== ""
            ? startTime.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })
            : "",
        submitted_date: endDate != null && endDate !== "" ? endDate.toLocaleDateString("en-CA") : "",
        submitted_time:
          endTime != null && endTime !== ""
            ? endTime.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })
            : "",
        km: kilometer ?? "",
        interiors: items.filter((item) => item.checked === true).map((item) => item.label),
        exteriors: exteriorItems.filter((item) => item.checked === true).map((item) => item.label),
        removed_interiors: itemsRemoved,
        removed_exteriors: exteriorItemsRemoved,
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitInspectionAPI(sanitizedData);
      } else {
        response = await updateInspectionAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400 && response.data?.error) {
        const validationTemp = {
          vehicle_id: "",
          type: "",
          start_date: "",
          start_time: "",
          submitted_date: "",
          submitted_time: "",
          km: "",
          interiors: "",
          exteriors: "",
          removed_interiors: "",
          removed_exteriors: "",
        };
        Object.entries(response.data.error).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) ? (value.length > 0 ? value[0] : "") : (typeof value === "string" ? value : "");
        });
        setErrorMsg(validationTemp);
      } else if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const getInspectionEdit = async (id) => {
    try {
      const response = await getInspectionEditApi(id);

      if (response.data.success === true) {
        const workOrderDetail = response.data.inspection ?? {};

        setLicensePlateOption({
          value: workOrderDetail.vehicle_id ?? "",
          label: workOrderDetail.lic_no ?? "",
        });
        setVehicleName(workOrderDetail.vehicle_name ?? "");
        setKilometer(workOrderDetail.km ?? "");
        setInspectionTypeOption({
          value: workOrderDetail.type ?? "",
          label: workOrderDetail.type ?? "",
        });
        // setStartDate(
        //   workOrderDetail.start_date != null &&
        //     workOrderDetail.start_date !== ""
        //     ? new Date(workOrderDetail.start_date)
        //     : null
        // );
        if (workOrderDetail.start_date != null && workOrderDetail.start_date !== "") {
          const parts = workOrderDetail.start_date.split("-");
          if (parts.length === 3) {
            const [day, month, year] = parts.map(Number);
            if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
              const date = new Date(year, month - 1, day);
              setStartDate(date);
            } else {
              console.error("Invalid date parts:", workOrderDetail.start_date);
              setStartDate(null);
            }
          } else {
            console.error("Date format not recognized:", workOrderDetail.start_date);
            setStartDate(null);
          }
        } else {
          setStartDate(null);
          console.log("No start date provided");
        }

        if (workOrderDetail.submitted_date != null && workOrderDetail.submitted_date !== "") {
          const parts = workOrderDetail.submitted_date.split("-");
          if (parts.length === 3) {
            const [day, month, year] = parts.map(Number);
            if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
              const date = new Date(year, month - 1, day); // month is zero-based
              setEndDate(date);
            } else {
              console.error("Invalid date parts:", workOrderDetail.submitted_date);
              setEndDate(null);
            }
          } else {
            console.error("Date format not recognized:", workOrderDetail.submitted_date);
            setEndDate(null);
          }
        } else {
          setEndDate(null);
        }

        if (workOrderDetail.start_time && typeof workOrderDetail.start_time === "string") {
          const parts = workOrderDetail.start_time.split(":");
          if (parts.length === 2) {
            const [hours, minutes] = parts.map(Number);
            if (!isNaN(hours) && !isNaN(minutes)) {
              const date = new Date();
              date.setHours(hours);
              date.setMinutes(minutes);
              date.setSeconds(0);
              date.setMilliseconds(0);
              setStartTime(date);
            }
          }
        }
        if (workOrderDetail.submitted_time && typeof workOrderDetail.submitted_time === "string") {
          const parts = workOrderDetail.submitted_time.split(":");
          if (parts.length === 2) {
            const [hours, minutes] = parts.map(Number);
            if (!isNaN(hours) && !isNaN(minutes)) {
              const date = new Date();
              date.setHours(hours);
              date.setMinutes(minutes);
              date.setSeconds(0);
              date.setMilliseconds(0);
              setEndTime(date);
            }
          }
        }

        if (workOrderDetail.interiors != null && workOrderDetail.interiors.length > 0) {
          workOrderDetail.interiors.forEach((item2) => {
            const index = items.findIndex((item1) => item1.label === item2);
            if (index !== -1) {
              items[index] = { ...items[index], checked: true };
            } else {
              items.push({ label: item2, checked: true, id: Date.now() }); // give new id
            }
          });
          setItems(items);
        }

        if (workOrderDetail.exteriors != null && workOrderDetail.exteriors.length > 0) {
          workOrderDetail.exteriors.forEach((item2) => {
            const index = exteriorItems.findIndex((item1) => item1.label === item2);
            if (index !== -1) {
              exteriorItems[index] = { ...exteriorItems[index], checked: true };
            } else {
              exteriorItems.push({
                label: item2,
                checked: true,
                id: Date.now(),
              }); // give new id
            }
          });
          setExteriorItems(exteriorItems);
        }
      } else {
        console.error("Error fetching inspection details:", response.data.message);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  return (
    <div>
      <div className=" px-3 bg-white d-flex align-items-center justify-content-between">
        <div className="d-flex gap-3 my-3">
          <MoveLeft className="cursor-pointer" onClick={() => navigate(-1)} />
          <p className="fw-semibold m-0">New inspection</p>
        </div>
        <div className="d-flex gap-3">
          <Button className="bg-white rounded-pill px-4 py-2 pagination-color btn-border-grey" onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button onClick={submitForm} className={`dark-purple-btn ${isLoader ? "disabled-btn" : ""} rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`} style={{ minWidth: "100px" }}>
            {isLoader ? <Spinner animation="border" size="sm" /> : id != null ? "Update" : "Save"}
          </Button>
        </div>
      </div>
      <div className="px-2 mt-2">
        <div className="bg-white rounded-4 p-3">
          <div className="row p-2">
            <p className="fs-18 fw-600  mb-0">Vehicle information</p>
            <div className="col-xl-4">
              <label htmlFor="plate" className="form-label  fw-400 d-flex">
                License Plate<span className="error-text">*</span>
              </label>
              <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select License Plate" value={licensePlateOption} onSelect={handleSelectLicensePlate} />
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.vehicle_id}
              </span>
            </div>
            <div className="col-xl-4">
              <label htmlFor="fill" className="form-label  fw-400">
                Vehicle Name
              </label>
              <input type="text" className="form-control rounded-3 vehicle-form-input" id="license" value={vehicleName} readOnly={true} />
            </div>
            <div className="col-xl-4">
              <label htmlFor="plate" className="form-label  fw-400 d-flex">
                Inspection type<span className="error-text">*</span>
              </label>
              <CommonStaticDropdown items={inspectionTypeList} placeholder="Select type" value={inspectionTypeOption} onSelect={handleInspectionTypeSelect} enableSearch={false} />
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.type}
              </span>
            </div>

            <div className="col-xl-2 d-flex flex-column">
              <label htmlFor="fill" className="form-label  fw-400 d-flex">
                Start date<span className="error-text">*</span>
              </label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd-mm-yyyy"
                customInput={
                  <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                    {startDate ? startDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd/mm/yyyy</span>}
                    <Calendar size={16} />
                  </button>
                }
              />
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.start_date}
              </span>
            </div>
            <div className="col-xl-2 d-flex flex-column">
              <label htmlFor="startTime" className="form-label fw-400 d-flex">
                Start time<span className="error-text">*</span>
              </label>
              <DatePicker
                selected={startTime}
                onChange={(time) => setStartTime(time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                customInput={
                  <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                    {startTime ? (
                      startTime.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    ) : (
                      <span style={{ color: "#8790A1" }}>hh:mm</span>
                    )}
                    <Clock size={16} />
                  </button>
                }
              />
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.start_time}
              </span>
            </div>
            <div className="col-xl-2 d-flex flex-column">
              <label htmlFor="fill" className="form-label  fw-400">
                Submitted date
              </label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                min={startDate}
                dateFormat="dd-MM-yyyy"
                customInput={
                  <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                    {endDate instanceof Date && !isNaN(endDate.getTime()) ? endDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>mm/dd/yyyy</span>}
                    <Calendar size={16} />
                  </button>
                }
              />

              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.submitted_date}
              </span>
            </div>

            <div className="col-xl-2 d-flex flex-column">
              <label htmlFor="endTime" className="form-label fw-400">
                Submitted time
              </label>
              <DatePicker
                selected={endTime}
                onChange={(time) => setEndTime(time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                customInput={
                  <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                    {endTime ? (
                      endTime.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    ) : (
                      <span style={{ color: "#8790A1" }}>hh:mm</span>
                    )}
                    <Clock size={16} />
                  </button>
                }
              />
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.submitted_time}
              </span>
            </div>
            <div className="col-xl-4">
              <label htmlFor="fill" className="form-label  fw-400">
                Kilometers
              </label>
              <input
                type="text"
                className="form-control rounded-3 vehicle-form-input"
                id="fill"
                placeholder="Enter KM"
                value={kilometer}
                onChange={(e) => {
                  setKilometer(e.target.value);
                }}
              />
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.km}
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6">
            <div className="bg-white p-3 rounded-4 mt-2">
              {/* Header */}
              <div className="d-flex align-items-center justify-content-between">
                <p className="m-0 fs-16 fw-600 d-flex" style={{ color: "#172B4D" }}>
                  Interior Details<span className="error-text">*</span>
                </p>

                <img src={plus} alt="plus" className="bg-primary p-2 rounded-circle" style={{ cursor: "pointer" }} onClick={() => setShowInteriorModal(true)} />
              </div>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.interiors}
              </span>
              {/* Scroll Checkbox */}
              <div
                className="mt-3"
                style={{
                  maxHeight: "340px",
                  overflowY: items.length > 5 ? "auto" : "visible",
                }}
              >
                {items.map((item) => (
                  <div
                    key={item.id}
                    className="d-flex align-items-center custom-checkbox justify-content-between p-3 rounded-3 mb-3"
                    style={{
                      backgroundColor: item.checked ? "#F5EAFE" : "#F9FAFB",
                      marginRight: items.length > 5 ? "5px" : "0px",
                    }}
                  >
                    <span>{item.label}</span>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={item.checked}
                      onChange={(e) => {
                        if (e.target.checked) {
                          // remove label if it was unchecked before
                          setItemsRemoved((prev) => prev.filter((lbl) => lbl !== item.label));
                        } else {
                          // add label if unchecked now (and avoid duplicates)
                          setItemsRemoved((prev) => (prev.includes(item.label) ? prev : [...prev, item.label]));
                        }

                        setItems((prev) => prev.map((x) => (x.id === item.id ? { ...x, checked: !x.checked } : x)));
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* Add Item Modal */}
          <Modal show={showInteriorModal} onHide={() => setShowInteriorModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Add Interior Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input type="text" value={newLabel} onChange={(e) => setNewLabel(e.target.value)} className="form-control" placeholder="Enter detail" />
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {newLabelError}
              </span>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowInteriorModal(false)}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  if (!newLabel.trim()) return;
                  const exist = items.filter((item) => item.label === newLabel.trim());
                  if (exist.length === 0) {
                    setItems((prev) => [
                      ...prev,
                      {
                        id: Date.now(),
                        label: newLabel.trim(),
                        checked: false,
                      },
                    ]);
                    setNewLabel("");
                    setNewLabelError("");
                    setShowInteriorModal(false);
                  } else {
                    setNewLabelError("Already Exists!");
                  }
                }}
              >
                Add
              </Button>
            </Modal.Footer>
          </Modal>

          <div className="col-xl-6">
            <div className="bg-white p-3 rounded-4 mt-2">
              {/* Header */}
              <div className="d-flex align-items-center justify-content-between">
                <p className="m-0 fs-16 fw-600 d-flex" style={{ color: "#172B4D" }}>
                  Exterior Details<span className="error-text">*</span>
                </p>

                <img src={plus} alt="plus" className="bg-primary p-2 rounded-circle" style={{ cursor: "pointer" }} onClick={() => setShowExteriorModal(true)} />
              </div>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.exteriors}
              </span>
              {/* Scroll Checkbox */}
              <div
                className="mt-3"
                style={{
                  maxHeight: "340px",
                  overflowY: exteriorItems.length > 5 ? "auto" : "visible",
                }}
              >
                {exteriorItems.map((item) => (
                  <div
                    key={item.id}
                    className="d-flex align-items-center custom-checkbox justify-content-between p-3 rounded-3 mb-3"
                    style={{
                      backgroundColor: item.checked ? "#F5EAFE" : "#F9FAFB",
                      marginRight: exteriorItems.length > 5 ? "5px" : "0px",
                    }}
                  >
                    <span>{item.label}</span>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={item.checked}
                      onChange={(e) => {
                        if (e.target.checked) {
                          // remove label if it was unchecked before
                          setExteriorItemsRemoved((prev) => prev.filter((lbl) => lbl !== item.label));
                        } else {
                          // add label if unchecked now (and avoid duplicates)
                          setExteriorItemsRemoved((prev) => (prev.includes(item.label) ? prev : [...prev, item.label]));
                        }

                        setExteriorItems((prev) => prev.map((x) => (x.id === item.id ? { ...x, checked: !x.checked } : x)));
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Add Item Modal */}
          <Modal show={showExteriorModal} onHide={() => setShowExteriorModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Add Exterior Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input type="text" value={newLabel} onChange={(e) => setNewLabel(e.target.value)} className="form-control" placeholder="Enter detail" />
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {newLabelError}
              </span>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowExteriorModal(false)}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  if (!newLabel.trim()) return;
                  const exist = exteriorItems.filter((item) => item.label === newLabel.trim());
                  if (exist.length === 0) {
                    setExteriorItems((prev) => [
                      ...prev,
                      {
                        id: Date.now(),
                        label: newLabel.trim(),
                        checked: false,
                      },
                    ]);
                    setNewLabel("");
                    setNewLabelError("");
                    setShowExteriorModal(false);
                  } else {
                    setNewLabelError("Already Exists!");
                  }
                }}
              >
                Add
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};
